import { addMethod, string, object, boolean } from 'yup';

import { nonCorporateEmails } from './constatnts';

export const corporateValidation = value => {
  // Check if value contains '@' and a '.' after '@' using secure string methods
  if (typeof value !== 'string') return true;

  const atIndex = value.indexOf('@');
  if (atIndex === -1) return true;

  const dotIndex = value.indexOf('.', atIndex);
  if (dotIndex === -1) return true;

  return !nonCorporateEmails.some(hostname => value.includes(hostname));
};

const phoneValidation = value => {
  if (!value) {
    return false;
  }

  return value.length >= 5 && value.length <= 18;
};

const telegramValidation = value => {
  const telegramUsername = /^@?[a-zA-Z0-9_]{5,32}$/u;

  return !(value && !telegramUsername.test(value));
};

const emojiValidation = value => {
  const regEx =
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1F0A0}-\u{1F0FF}\u{1F100}-\u{1F1FF}\u{1F200}-\u{1F2FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{25A0}-\u{25FF}\u{2B00}-\u{2BFF}\u{3030}\u{303D}\u{3297}\u{3299}]/u;

  return !regEx.test(value);
};

addMethod(string, 'checkCorporateEmail', function (message) {
  return this.test('checkCorporateEmail', message, function (value) {
    const { createError } = this;
    return corporateValidation(value) || createError({ path: 'notCorporateEmail', message });
  });
});

addMethod(string, 'checkPhone', function (message) {
  return this.test('checkPhone', message, function (value) {
    return phoneValidation(value);
  });
});

addMethod(string, 'checkEmoji', function (message) {
  return this.test('checkEmoji', message, function (value) {
    return emojiValidation(value);
  });
});

addMethod(string, 'checkTelegram', function (message) {
  return this.test('checkTelegram', message, function (value) {
    return telegramValidation(value);
  });
});

const corporateEmail = messages => {
  return string()
    .email(messages.required)
    .matches(/^[a-zA-Z0-9_-]{1,64}[.@a-zA-Z0-9-]{1,63}?\.[a-z]{2,6}$/, {
      message: messages.required,
    })
    .required(messages.required);
};

const phone = messages => {
  const message = 'Пожалуйста, введите номер телефона';

  return string()
    .required(messages || message)
    .checkPhone(messages || message);
};

const telegram = messages => {
  return string().checkTelegram(messages.telegram).checkEmoji(messages.emoji);
};

export const corporateFormSchema = messages => {
  return object().shape(
    {
      name: string().required(messages.name).checkEmoji(messages.emoji),
      email: corporateEmail(messages.email),
      phone: phone(messages.phone),
      telegram: telegram(messages),
      message: string().required(messages.message).checkEmoji(messages.emoji),
      NDA: boolean(),
    },
    ['email', 'phone'],
  );
};
